export interface TrendItem {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  trend: "up" | "down" | "new";
}

export interface HotCommentTopic {
  id: string;
  category: string;
  title: string;
  summary: string;
  agree: number;
  oppose: number;
  wind: string;
  comments: string[];
}

export interface DebateItem {
  id: string;
  topic: string;
  forLabel: string;
  forText: string;
  forComments: string[];
  againstLabel: string;
  againstText: string;
  againstComments: string[];
  readTime: string;
}

export interface CategoryItem {
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export interface ArticleItem {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  views: number;
  image: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface TestimonialItem {
  nickname: string;
  avatar: string;
  role: string;
  text: string;
}

export const trends: TrendItem[] = [
  { rank: 1, title: "远程办公到底是效率革命还是形式主义？评论区吵了三天", tag: "职场", heat: 1284000, trend: "up" },
  { rank: 2, title: "国货涨价背后的消费心理，大家怎么看？", tag: "消费", heat: 986000, trend: "up" },
  { rank: 3, title: "AI 生成内容该不该标注来源？两边都有理", tag: "科技", heat: 874000, trend: "new" },
  { rank: 4, title: "00 后整顿职场，是真个性还是新冲突？", tag: "社会", heat: 760000, trend: "down" },
  { rank: 5, title: "“班味”咖啡文化走红，是解压还是焦虑营销？", tag: "生活", heat: 653000, trend: "up" },
  { rank: 6, title: "景区预约制该不该保留？假期出行之争持续发酵", tag: "生活", heat: 521000, trend: "new" },
  { rank: 7, title: "宠物经济火热，为宠物花钱到底值不值？", tag: "消费", heat: 438000, trend: "down" },
];

export const hotComments: HotCommentTopic[] = [
  {
    id: "hc1",
    category: "职场",
    title: "被 AI 抢走的第一份工作，是谁的锅？",
    summary: "一家公司用 AI 批量生成初稿后宣布裁掉文案岗，消息一出评论区迅速分成三派：支持“工具论”、反对“降本论”、围观“迟早轮到我”。风向已从幸灾乐祸转向真实焦虑。",
    agree: 6280,
    oppose: 4120,
    wind: "警惕“降本”叙事",
    comments: [
      "骂 AI 没意义，老板用它是为了省钱，不是因为更聪明。",
      "我就被裁了，现在反而在看 AI 教程，慌归慌，得先自救。",
      "AI 写得再快，没有审美和分寸感就是一堆废话。",
    ],
  },
  {
    id: "hc2",
    category: "生活",
    title: "年轻人选择“低物欲”生活，是清醒还是躺平？",
    summary: "一篇关于极简消费的帖子引发热议，支持者认为这是对抗消费主义的清醒，反对者担忧是经济预期下行的被动选择。两种声音背后是对“体面”定义的分歧。",
    agree: 9810,
    oppose: 5340,
    wind: "清醒与无奈并存",
    comments: [
      "不是不想买，是性价比算明白了，钱要花在刀刃上。",
      "低物欲听着高级，真遇事没存款就知道难受。",
      "消费降级最怕的是连体验都被一起降级。",
    ],
  },
  {
    id: "hc3",
    category: "科技",
    title: "AI 生成图署名版权，创作者到底该不该署名？",
    summary: "设计师作品被一键“AI 仿制”后未署名引发版权讨论，评论区争论焦点从“技术是否公平”转向“平台责任与个人维权成本”。多角度观点碰撞激烈。",
    agree: 4490,
    oppose: 5200,
    wind: "平台责任被重点追问",
    comments: [
      "问题是平台没说清楚训练数据从哪来，这个漏洞必须补。",
      "普通画师维权成本太高，输的不是技术是时间。",
      "别一竿子打死 AI，创作者用得好也能放大价值。",
    ],
  },
  {
    id: "hc4",
    category: "社会",
    title: "地铁上外放短视频，该由谁来管？",
    summary: "一段地铁外放引发的冲突视频走红，评论区出现“支持乘客合理提醒”“建议制度处罚”“双方都有问题”三种主流声音，争论焦点指向公共空间的边界感。",
    agree: 7360,
    oppose: 2900,
    wind: "多数支持公共守则",
    comments: [
      "公共空间是共享的，戴耳机是最基本的礼貌。",
      "吵起来谁都难看，靠自觉不如靠明确规则。",
      "大家都不容易，但自己的方便不该让他人买单。",
    ],
  },
];

export const debates: DebateItem[] = [
  {
    id: "db1",
    topic: "下班后该不该秒回工作消息？",
    forLabel: "支持随时响应",
    forText: "即时沟通是团队效率的一部分，及时回复能降低协作成本，也在意外面前显得可靠，尤其适合客户导向与高协同型团队。",
    forComments: ["客户就等你回一句，回复慢可能单就黄了。", "大家配合顺畅，彼此靠谱，效率反而更高。"],
    againstLabel: "支持彻底断联",
    againstText: "私人时间同样需要被尊重，边界清晰才能长久工作。频繁被打断会透支精力，也容易把焦虑传导给整个团队。",
    againstComments: ["手机静音那一刻，我才觉得自己还活着。", "工作不是救火，边界感是成年人的专业。"],
    readTime: "约 3 分钟",
  },
  {
    id: "db2",
    topic: "旅行到底要不要做详细攻略？",
    forLabel: "攻略派",
    forText: "攻略能避开排队与踩雷，时间有限的假期值得被规划。提前了解路线和天气，能让每一分预算都花得安心。",
    forComments: ["上次没规划，到了景点只剩排队的份儿。", "做攻略也是一种乐趣，把期待拉满。"],
    againstLabel: "随性派",
    againstText: "过度攻略会失去偶遇的惊喜，人被行程推着走反而更累。留白才是旅行的浪漫，迷路也有别样的风景。",
    againstComments: ["跟着导航看攻略，感觉像在上班。", "最喜欢转角遇到的巷子和陌生人闲聊。"],
    readTime: "约 2 分钟",
  },
  {
    id: "db3",
    topic: "存钱重要还是体验当下重要？",
    forLabel: "先攒钱",
    forText: "安全感来自兜里的底气。先储蓄再消费，才能在面对风险时不慌，也才有资格在未来谈选择与自由。",
    forComments: ["存款是我拒绝不合理要求的底气。", "现在省的每一分都是以后选择的筹码。"],
    againstLabel: "先体验",
    againstText: "青春与健康是不可逆的资产。适度为体验买单，收获的是见识与回忆，它们同样塑造一个人的未来竞争力。",
    againstComments: ["有些风景现在不看，以后再也看不到了。", "体验塑造认知，认知才能换来机会。"],
    readTime: "约 2 分钟",
  },
];

export const categories: CategoryItem[] = [
  { name: "社会观察", desc: "议题为何发酵，舆论如何分野", icon: "ri-earth-line", count: 328 },
  { name: "职场江湖", desc: "工作方式与职场文化之争", icon: "ri-briefcase-4-line", count: 276 },
  { name: "科技潮向", desc: "技术落地引发的真问题", icon: "ri-cpu-line", count: 254 },
  { name: "消费心理", desc: "花与不花背后的选择逻辑", icon: "ri-shopping-bag-3-line", count: 198 },
  { name: "生活哲学", desc: "把日常过成值得讨论的题", icon: "ri-cup-line", count: 183 },
  { name: "娱乐百态", desc: "热门话题与观众真实反馈", icon: "ri-remixicon-fill", count: 167 },
];

export const articles: ArticleItem[] = [
  {
    id: "a1",
    category: "职场",
    title: "拆解一场“裁员”热帖：评论区风向是如何逆转的",
    excerpt: "从最初的集体义愤，到有人开始追问背景，再到方法论式讨论，我们用一张时间轴还原舆论的三个拐点。",
    date: "2026-09-04",
    readTime: "约 6 分钟",
    views: 48200,
    image: "https://readdy.ai/api/search-image?query=editorial%20abstract%20workplace%20illustration%20in%20warm%20terracotta%20cream%20and%20deep%20teal%20palette%2C%20a%20meeting%20table%20with%20laptop%20and%20debate%20speech%20shapes%2C%20minimal%20flat%20modern%20graphic%20style%2C%20high%20detail%20clean%20composition&width=900&height=640&seq=art-wz-01&orientation=portrait",
  },
  {
    id: "a2",
    category: "消费",
    title: "一杯咖啡凭什么卖到 50 元？热评里的价值分歧",
    excerpt: "评论区最尖锐的分歧，不是价格本身，而是我们愿意为什么样的“情绪价值”买单，以及它到底值不值。",
    date: "2026-09-02",
    readTime: "约 5 分钟",
    views: 36100,
    image: "https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20a%20coffee%20cup%20with%20rising%20price%20tag%20and%20floating%20coins%2C%20warm%20amber%20terracotta%20cream%20palette%2C%20minimal%20flat%20modern%20graphic%20style%2C%20clean%20high%20detail&width=900&height=640&seq=art-xf-02&orientation=portrait",
  },
  {
    id: "a3",
    category: "科技",
    title: "AI 时代的“代写”争议：哪些边界正在被重新划定",
    excerpt: "当 AI 参与作业、报告甚至创作，原创与辅助的边界模糊了。我们梳理了争论中反复出现的五组对立观点。",
    date: "2026-08-29",
    readTime: "约 7 分钟",
    views: 42900,
    image: "https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20ai%20neural%20network%20and%20pencil%20merging%20in%20terracotta%20deep%20teal%20and%20cream%20palette%2C%20minimal%20flat%20modern%20graphic%20style%2C%20high%20detail&width=900&height=640&seq=art-kj-03&orientation=portrait",
  },
  {
    id: "a4",
    category: "生活",
    title: "告别打卡式旅游：年轻人的假期正在“反内卷”",
    excerpt: "越来越多评论把旅游视为一种情绪出口而非任务清单。从评论区看，松弛感正取代“到此一游”成为新共识。",
    date: "2026-08-25",
    readTime: "约 4 分钟",
    views: 28800,
    image: "https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20traveler%20with%20backpack%20walking%20toward%20mountains%20and%20open%20sky%2C%20warm%20cream%20terracotta%20amber%20palette%2C%20minimal%20flat%20modern%20graphic%20style%2C%20clean%20detail&width=900&height=640&seq=art-sh-04&orientation=portrait",
  },
  {
    id: "a5",
    category: "社会",
    title: "让座争论的背后：我们在争的其实是什么？",
    excerpt: "一次让座引发的争吵，暴露的是代际、公共资源与边界感的叠加。评论区里，真正的共识或许是“好好说话”。",
    date: "2026-08-20",
    readTime: "约 5 分钟",
    views: 31200,
    image: "https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20subway%20carriage%20seats%20with%20two%20speech%20bubbles%20facing%20each%20other%2C%20warm%20terracotta%20cream%20teal%20palette%2C%20minimal%20flat%20graphic%20style%2C%20clean%20detail&width=900&height=640&seq=art-sh-05&orientation=portrait",
  },
  {
    id: "a6",
    category: "消费",
    title: "从“野性消费”到“理性比价”，舆论风向变在哪了",
    excerpt: "消费者的耐心正在变化。评论区的高赞早已从情绪站队，转向对性价比、品质和售后实打实的讨论。",
    date: "2026-08-16",
    readTime: "约 6 分钟",
    views: 27400,
    image: "https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20shopping%20cart%20with%20magnifying%20glass%20and%20scales%2C%20warm%20amber%20cream%20terracotta%20palette%2C%20minimal%20flat%20modern%20graphic%20style%2C%20clean%20high%20detail&width=900&height=640&seq=art-xf-06&orientation=portrait",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "九一吃瓜的内容是怎么来的？",
    a: "我们不做无中生有的造谣内容。九一吃瓜围绕已公开的公共议题、热点事件与网络讨论展开，编辑会筛选有代表性的网友热评与观点，从多角度还原舆论脉络，帮助读者看清“大家怎么看”，而不是代替读者下结论。",
  },
  {
    q: "为什么有些话题的评论是“两边都有理”？",
    a: "真实舆论很少是一边倒的。我们在“争论焦点”栏目里刻意保留对立的两种主流声音，并按占比和互动量整理，既不刻意偏向某一方，也不刻意营造对立，只为客观呈现讨论本身的样子。",
  },
  {
    q: "你们的“风向”结论是怎么得出的？",
    a: "我们的编辑部会综合评论区的点赞量、讨论密度与观点分布，归纳出阶段性主流情绪，例如“警惕、支持、观望”。它反映的是当下多数参与讨论者的倾向，会随事态发展持续更新，并非一成不变的定论。",
  },
  {
    q: "我想投稿或纠正某条观点，应该怎么做？",
    a: "欢迎通过页面底部邮箱与我们联系。如果发现某条观点代表性不足或归类有误，请附上原始讨论链接，我们会在一到两个工作日内核实并处理，确保内容客观可溯源。",
  },
  {
    q: "九一吃瓜适合什么样的人看？",
    a: "适合想快速了解公共议题舆论风向、希望看到多角度观点、而不是只听单一声音的读者。无论你是围观者、参与者，还是想找讨论切入点的人，都能在这里快速掌握来龙去脉与争论焦点。",
  },
];

export const testimonials: TestimonialItem[] = [
  {
    nickname: "一只慢热的橘猫",
    avatar: "",
    role: "深度读者",
    text: "第一次在一件事上看到这么清楚的两派梳理，终于不是被带节奏了，而是真的看懂了大家在吵什么。",
  },
  {
    nickname: "程序员的下午茶",
    avatar: "",
    role: "订阅者",
    text: "AI 那篇把“降本论”和“工具论”拆得很明白，评论区原文也保留得真实，读完有启发。",
  },
  {
    nickname: "想躺平的阿盐",
    avatar: "",
    role: "普通网友",
    text: "喜欢这种不做价值审判的写法，把我心里那个摇摆的念头讲清楚了，原来我并不孤单。",
  },
];